/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IceIceYetiGameAssets} from "../IceIceYetiGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class IceIceYetiIntroView extends StillImageBgIntroView {

    private static LOGO_LANDSCAPE_OFFSET_Y:number = 40;
    private static LOGO_PORTRAIT_OFFSET_Y:number = 100;

    private _logo:PIXI.Sprite;
    private _logoYeti:PIXI.Sprite;
    private _logoShadow:PIXI.Sprite;
    private _logoContainer:PIXI.Container;
    private _winWays:PIXI.Sprite;

    constructor(config:IStillImageBgIntroViewConfig) {
        config.buttonSize = new PIXI.Point(320, 74);
        super(config);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._logoContainer = new PIXI.Container();

        this._winWays = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.WINWAYS)[0]);
        this._winWays.anchor.set(0.5, 0.5);
        this._winWays.position.set(250 + (this._winWays.width / 2), (this._winWays.height / 2));
        this.addChild(this._winWays);

        this._logoShadow = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.LOGO_SHADOW)[0]);
        this._logoShadow.anchor.set(0.5, 0.5);
        this._logoShadow.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this._logoShadow.position.y = 10;
        this._logoContainer.addChild(this._logoShadow);

        this._logo = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.LOGO)[0]);
        this._logo.anchor.set(0.5, 0.5);
        this._logoContainer.addChild(this._logo);

        this._logoYeti = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.LOGO_YETI)[0]);
        this._logoYeti.anchor.set(0.5, 0.5);
        this._logoYeti.position.set(35.5, -54);
        this._logoContainer.addChild(this._logoYeti);

        return this._logoContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._logoContainer.scale.set(this._orientationScale, this._orientationScale);
        this._winWays.scale.set(this._orientationScale, this._orientationScale);
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            this._logoContainer.position.set(this._screenWidth / 2, (this._screenHeight / 2) - IceIceYetiIntroView.LOGO_LANDSCAPE_OFFSET_Y);
            this._winWays.rotation = 0;
            this._winWays.position.set(250 + (this._winWays.width / 2), (this._winWays.height / 2));
        } else {
            this._logoContainer.position.set(this._screenWidth / 2, (this._screenHeight / 2) - IceIceYetiIntroView.LOGO_PORTRAIT_OFFSET_Y);
            this._winWays.rotation = -0.4;
            this._winWays.position.y = 200;
            this._winWays.position.x = 455;
        }
    }

    protected onResizeBackground(resizeData:IResizeData):void {
        super.onResizeBackground(resizeData);
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            this._background.rotation = 0;
        } else {
            this._background.rotation = 1.5708;
            const background:PIXI.Sprite = <PIXI.Sprite>this._background;
            background.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
            const scale:number = Math.max(this._screenWidth / background.texture.height, this._screenHeight / background.texture.width);
            background.scale.set(scale, scale);
        }
    }
}